import { useContractFunction } from "@usedapp/core";
import { utils } from "ethers";
import { Contract } from "@ethersproject/contracts";
import NFTAirdropDistributor from "@/chain-info/contracts/NFTAirdropDistributor.json";

export const useUpdateNFTAirdrop = (NFTAddress: string) => {
  const { abi } = NFTAirdropDistributor;
  const nftAirdropFactoryInterface = new utils.Interface(abi);
  const nftAirdropFactoryContract = new Contract(
    NFTAddress,
    nftAirdropFactoryInterface
  );

  const { send: updateSend, state: updateNFTAirdropState } =
    useContractFunction(nftAirdropFactoryContract as any, "updateBaseInfoURI", {
      transactionName: "Update Campaign",
    });
  const updateNFTAirdrop = (ipfs: string) => {
    console.log("HERE:", ipfs);

    return updateSend(ipfs);
  };
  return { updateNFTAirdrop, updateNFTAirdropState };
};
